<script lang="ts">
  import { scrollOnActive } from '$lib/actions/scrollOnActive';
  import { CookieDismiss, dismissCookieBanner } from '$lib/utils/cookie';

  export let path: string;
  export let categoryName: string;
  export let isActive: boolean;
  export let handleClick: (categoryName: string) => void;
</script>

<a
  href={path}
  class="category-link"
  class:active={isActive}
  use:scrollOnActive={[isActive]}
  on:click={() => {
    handleClick(categoryName);
    dismissCookieBanner(CookieDismiss.TOP_NAV);
  }}
>
  <span class="category-name" class:active-text={isActive}>{categoryName}</span>
</a>

<style lang="scss">
  .category-link {
    display: flex;
    align-items: center;
    padding: 6px 10px;
    text-decoration: none;
    // margin-right: 12px;
  }
  .category-name {
    font-size: var(--font-size-base);
    font-weight: var(--font-weight-semibold);
    color: var(--color-title);
    opacity: 0.5;
  }

  .active {
    border-bottom: 2px solid red;
  }

  .active-text {
    opacity: 1;
  }
</style>
